import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import Container from './Container';


export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
    </Router>
  </Container>
);
